import gql from "graphql-tag";

// eslint-disable-next-line import/no-default-export
export default gql`
query customersLookup(
	$skip: Int
	$take: Int
	$where: CustomerLookupFilterInput
	$order: [CustomerLookupSortInput!]
	$activeOnly: Boolean
) {
	customersLookup(
	activeOnly: $activeOnly
	skip: $skip
	take: $take
	where: $where
	order: $order
)    {
      pageInfo{
        hasNextPage,
        hasPreviousPage
      },

        items {
        	active,
            customer {
                id, naam, postcode, straat, huisnummer, plaats, emailadres, naamSamengesteld
            },
            broker { id, naam}
        }
    }
}`;
